import { AlertTriangle, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { DISCLAIMER } from "@/data/content";
import { PRIVACY, TERMS } from "@/data/legal";

export default function Footer() {
  return (
    <footer id="iletisim" className="bg-white">
      <div className="border-t border-slate-200 bg-slate-50">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex items-start gap-4">
          <AlertTriangle className="w-9 h-9 text-slate-400 shrink-0 mt-0.5" strokeWidth={1.6} />
          <p className="text-slate-500 text-xs sm:text-sm leading-relaxed">{DISCLAIMER}</p>
        </div>
      </div>

      <div className="bg-navy text-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid gap-10 md:grid-cols-3">
          {/* Brand */}
          <div>
            <span className="font-extrabold text-white text-lg tracking-tight">
              TÜRKİYE BORSA ROBOTU
            </span>
            <p className="text-white/60 text-sm leading-relaxed mt-4 max-w-xs">
              Güçlü geçmiş, güvenli gelecek. Türkiye sermaye piyasaları hakkında güvenilir
              bilgi kaynağınız.
            </p>
          </div>

          {/* İletişim */}
          <div data-testid="footer-contact">
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-[0.2em]">
              İletişim
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:info@turkiyeborsarobotu.com"
                  data-testid="footer-email"
                  className="inline-flex items-center gap-3 text-white/75 hover:text-gold transition-colors text-sm"
                >
                  <span className="grid place-items-center w-9 h-9 rounded-lg bg-white/10">
                    <Mail className="w-4 h-4" />
                  </span>
                  info@turkiyeborsarobotu.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+905391180130"
                  data-testid="footer-phone"
                  className="inline-flex items-center gap-3 text-white/75 hover:text-gold transition-colors text-sm"
                >
                  <span className="grid place-items-center w-9 h-9 rounded-lg bg-white/10">
                    <Phone className="w-4 h-4" />
                  </span>
                  +90 539 118 01 30
                </a>
              </li>
            </ul>
          </div>

          {/* Yasal */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-[0.2em]">
              Yasal
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to={PRIVACY.slug}
                  data-testid="footer-privacy-link"
                  className="text-white/75 hover:text-gold transition-colors text-sm"
                >
                  {PRIVACY.title}
                </Link>
              </li>
              <li>
                <Link
                  to={TERMS.slug}
                  data-testid="footer-terms-link"
                  className="text-white/75 hover:text-gold transition-colors text-sm"
                >
                  {TERMS.title}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 text-center text-white/50 text-xs">
            © {new Date().getFullYear()} Türkiye Borsa Robotu. Tüm hakları saklıdır.
          </div>
        </div>
      </div>
    </footer>
  );
}
